import React, { useEffect, useState } from "react";
import { Grid } from "antd";
import { api } from "../../../Api/mockApi";
import DesktopBoard from "./DesktopBoard";
import MobileBoard from "./MobileBoard";

const { useBreakpoint } = Grid;

export default function DesignerBoard() {
  const [leads, setLeads] = useState([]);
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  useEffect(() => {
    api.getLeads().then(setLeads);
  }, []);

  const update = (id, status) => {
    api.updateStatus(id, status);
    setLeads((leads) => leads.map((l) => (l.id === id ? { ...l, status } : l)));
  };

  return (
    <div>
      <div className="page-wrapper" style={{ padding: "120px 0" }}>
        <div className="content">
          {isMobile ? (
            <MobileBoard leads={leads} onMove={update} />
          ) : (
            <DesktopBoard leads={leads} onMove={update} />
          )}
        </div>
      </div>
    </div>
  );
}
